import React, { useState, useEffect } from "react";
import { Button, Col, Descriptions, Divider, Form, InputNumber, Layout, Skeleton, Row, Table, Tag, Typography } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { inject, observer } from 'mobx-react'
import "./style.scss";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment-timezone";
import { cloneDeep } from "lodash";

const { Content } = Layout;
const { Text } = Typography;

const ViewVoter = ({ voterStore }) => {

  const { Title } = Typography;
  const navigate = useNavigate();
  let { id } = useParams();

  const [showData, setShowData] = useState(false);

  // const voterName = voterStore.voter && voterStore.voter.FullName;
  const statusPending = 'PENDING';
  const statusReceived = 'RECEIVED';

  useEffect(() => {
    voterStore.page = 1;
    voterStore.hasMore = false;
    voterStore.perPage = 10;

    // Clear previous voter data
    voterStore.voter = null;
    voterStore.votersCashAmounts = [];
    voterStore.votersItemAmounts = [];
    
    if(id){
      voterStore.fetchVoterByID(id);
      voterStore.fetchVoterAmountByID(id);
    }
  }, [id]);

  useEffect(() => {
    voterStore.page = 1;
    voterStore.hasMore = false;
    voterStore.perPage = 10;
    
    const timeout = setTimeout(() => {
      setShowData(true);
    }, 500);

    return () => clearTimeout(timeout); // Clear the timeout if the component is unmounted

  }, []);

  useEffect(() => {
    if (!voterStore.voter || !voterStore.voter.FullName) return;
  
    voterStore.pageCash = 1;
    voterStore.hasMoreCash = false;
    voterStore.perPageCash = 10;
  
    voterStore.pageItem = 1;
    voterStore.hasMoreItem = false;
    voterStore.perPageItem = 20;
  
    voterStore.fetchVotersEventRegistrationPendingByName(voterStore.voter.FullName, statusPending);
    voterStore.fetchVotersEventRegistrationReceivedByName(voterStore.voter.FullName, statusReceived);
  
  }, [voterStore.voter?.FullName]);

  const handlePrevPage = () => {
    voterStore.page = voterStore.page - 1;
    if(id){
      voterStore.fetchVoterAmountByID(id);
    }
  };

  const handleNextPage = () => {
    voterStore.page = voterStore.page + 1;
    if(id){
      voterStore.fetchVoterAmountByID(id);
    }
  };

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  const columnsRegistered = [
    {
      title: 'ID',
      key: 'DisplayedID+EventRegistrationID',
      dataIndex: 'DisplayedID',
      render: (DisplayedID) => (
        <Text default strong>{DisplayedID}</Text>
      )
    },
    {
      title: 'Event Name',
      key: 'EventName+EventRegistrationID',
      dataIndex: 'EventName',
      render: (EventName) => (
        <Text default>{EventName}</Text>
      )
    },
    {
      title: 'Name',
      key: 'VoterName+EventRegistrationID',
      dataIndex: 'VoterName',
      render: (VoterName) => (
        <Text default>{VoterName}</Text>
      )
    },

    {
      title: 'Status',
      dataIndex: 'Status',
      responsive: ['lg', 'xl', 'md'],
      render: (Status) => (
        <Text default strong><Tag color={Status === 'RECEIVED' ? 'green' : 'blue'}>{Status}</Tag></Text>
      )
    },
    {
      title: 'Transaction Date',
      key: 'CreatedAt+VotersAmountID',
      dataIndex: 'CreatedAt',
      responsive: ['lg', 'xl', 'md'],
      render: (CreatedAt) => (
        <Text default>{moment.utc(CreatedAt).format("MMM DD, YYYY")}</Text>
      )
    },
  ];

  const columnsReceived = [
    {
      title: 'ID',
      key: 'DisplayedID+EventRegistrationID',
      dataIndex: 'DisplayedID',
      render: (DisplayedID) => (
        <Text default strong>{DisplayedID}</Text>
      )
    },
    {
      title: 'Event Name',
      key: 'EventName+EventRegistrationID',
      dataIndex: 'EventName',
      render: (EventName) => (
        <Text default>{EventName}</Text>
      )
    },
    {
      title: 'Name',
      key: 'VoterName+EventRegistrationID',
      dataIndex: 'VoterName',
      render: (VoterName) => (
        <Text default>{VoterName}</Text>
      )
    },

    {
      title: 'Status',
      key: 'Status+EventRegistrationID',
      dataIndex: 'Status',
      render: (Status) => (
        <Text default strong><Tag color={Status === 'RECEIVED' ? 'green' : 'blue'}>{Status}</Tag></Text>
      )
    },
    {
      title: 'Transaction Date',
      key: 'CreatedAt+VotersAmountID',
      dataIndex: 'CreatedAt',
      responsive: ['lg', 'xl', 'md'],
      render: (CreatedAt) => (
        <Text default>{moment.utc(CreatedAt).format("MMM DD, YYYY")}</Text>
      )
    },
  ];

  const columns = [
      // {
      //   title: 'Type',
      //   dataIndex: 'Type',
      //   key: 'Type',
      //   render: (Type) => (
      //     <Tag color={'green'}><Text type="primary" strong>{Type}</Text></Tag>
      //   )
      // },
      {
        title: 'Event Name',
        key: 'EventName+VotersAmountID',
        dataIndex: 'EventName',
        responsive: ['lg', 'xl', 'md'],
        render: (EventName) => (
          <Text default>{EventName}</Text>
        )
      },
      {
        title: 'Item Name',
        dataIndex: 'ItemName',
        key: 'ItemName',
        render: (ItemName) => (
          <Text type="primary" strong>{ItemName ? ItemName : "Cash"}</Text>
        )
      },
      {
        title: 'PPU',
        dataIndex: 'PricePerUnit',
        key: 'PricePerUnit',
        render: (PricePerUnit) => (
          <Text type="primary" strong>{PricePerUnit ? PricePerUnit : "-"}</Text>
        )
      },
      {
        title: 'Quantity',
        dataIndex: 'Quantity',
        key: 'Quantity',
        render: (Quantity) => (
          <Text type="primary" strong>{Quantity ? Quantity : "-"}</Text>
        )
      },
      {
        title: 'Amount',
        key: 'Amount+VotersAmountID',
        dataIndex: 'Amount',
        responsive: ['lg', 'xl', 'md'],
        render: (Amount, record) => (
          <Text default strong>₱{formatNumber(Amount)}</Text>
        )
      },
      {
        title: 'Transaction Date',
        key: 'CreatedAt+VotersAmountID',
        dataIndex: 'CreatedAt',
        responsive: ['lg', 'xl', 'md'],
        render: (CreatedAt) => (
          <Text default>{moment.utc(CreatedAt).format("MMM DD, YYYY")}</Text>
        )
      },
      // {
      //   title: 'Transact By',
      //   key: 'LoadedBy+VotersAmountID',
      //   dataIndex: 'LoadedBy',
      //   responsive: ['lg', 'xl', 'md'],
      //   render: (LoadedBy) => (
      //     <Tag><Text type="primary" strong>{LoadedBy}</Text></Tag>
      //   )
      // },
    ];

  const handlePrevPageCash = () => {
    voterStore.pageCash = voterStore.pageCash - 1;

    voterStore.fetchVotersEventRegistrationPendingByName(voterStore.voter.FullName, statusPending);
  };

  const handleNextPageCash = () => {
    voterStore.pageCash = voterStore.pageCash + 1;

    voterStore.fetchVotersEventRegistrationPendingByName(voterStore.voter.FullName, statusPending);
  };

  const handlePrevPageItem = () => {
    voterStore.pageItem = voterStore.pageItem - 1;

    voterStore.fetchVotersEventRegistrationReceivedByName(voterStore.voter.FullName, statusReceived);
  };

  const handleNextPageItem = () => {
    voterStore.pageItem = voterStore.pageItem + 1;

    voterStore.fetchVotersEventRegistrationReceivedByName(voterStore.voter.FullName, statusReceived);
  };

  return (
    <div className="view-voter">
      <Content>
        <div className="view-voter-content">
          <Title level={4}>Voter Details</Title>
          <Divider />
          {
            showData ? (
              <>
                <div className="information">
                  <Descriptions column={2} bordered>
                    <Descriptions.Item label="VIN" span={1}>
                      <Text type="primary" strong>{ voterStore.voter && voterStore.voter.VIN }</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="Is the Person With Disabilities?" span={1}>
                      <Text type="primary" strong>{ voterStore.voter && voterStore.voter.PWD }</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="PRECINCT" span={1}>
                      <Text type="primary" strong>{ voterStore.voter && voterStore.voter.Precint }</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="Illiterate?" span={1}>
                      <Text type="primary" strong>{ voterStore.voter && voterStore.voter.Illiterate }</Text>
                    </Descriptions.Item>
                  </Descriptions>
                  <Divider/>
                  <Title level={5}>Personal Information</Title>
                  <Descriptions column={2} bordered>
                    <Descriptions.Item label="Name" span={2}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.FullName }</Text></Descriptions.Item>
                    <Descriptions.Item label="Birth Date" span={2}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.DateOfBirth } ({ moment(voterStore.voter && voterStore.voter.DateOfBirth).format("MMM DD, YYYY") })</Text> </Descriptions.Item>
                    <Descriptions.Item label="Sex" span={1}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.Sex }</Text></Descriptions.Item>
                    <Descriptions.Item label="Civil Status" span={1}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.CivilStatus }</Text></Descriptions.Item>
                  </Descriptions>
                  <Divider/>
                  <Descriptions column={2} bordered>
                    <Descriptions.Item label="Contact Number" span={1}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.MobileNo }</Text></Descriptions.Item>
                    <Descriptions.Item label="Email" span={1}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.Email }</Text></Descriptions.Item>
                    <Descriptions.Item label="Street" span={2}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.Street }</Text></Descriptions.Item>
                    <Descriptions.Item label="Address" span={2}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.Address }</Text></Descriptions.Item>
                  </Descriptions>
                  <Divider/>
                  <Descriptions column={2} bordered layout="vertical">
                    <Descriptions.Item label="Remarks" span={1}><Text type="primary" strong>{ voterStore.voter && voterStore.voter.RemarksA }</Text></Descriptions.Item>
                  </Descriptions>

                  <Title level={5}>Voters Event Registration History - <Tag color="blue">PENDING</Tag></Title>
                  <Table pagination={false} columns={columnsRegistered} dataSource={cloneDeep(voterStore.votersCashAmounts)} bordered
                    expandable={{
                      expandedRowRender: (record) => (
                        <>
                        <Title level={5}>Item Details</Title>
                        <Row gutter={20}>
                          <Col>
                            <Text type="primary">Item : </Text><Text type="primary" strong>{record.ItemName ? record.ItemName : "N/A"}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Quantity : </Text><Text type="primary" strong>{record.ItemQuantity}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Price Per Unit : </Text><Text type="primary" strong>₱{formatNumber(record.ItemPricePerUnit)}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Item Amount : </Text><Text type="primary" strong>₱{formatNumber(record.ItemTotalAmount)}</Text>
                          </Col>
                        </Row>
                        <Title level={5}>Cash Details</Title>
                        <Row gutter={20}>
                          <Col>
                            <Text type="primary">Item : </Text><Text type="primary" strong>Cash</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Cash Amount : </Text><Text type="primary" strong>₱{formatNumber(record.Cash)}</Text>
                          </Col>
                        </Row>
                        </>
                      ),
                      // rowExpandable: (record) => record.name !== 'Not Expandable',
                    }}
                  />
                  <ul className="pagination">
                    <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPageCash} disabled={voterStore.pageCash == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                    <li className="pagination-item"><a>{voterStore.pageCash}</a></li>
                    <li className="pagination-next "><Button type="dashed" onClick={handleNextPageCash} disabled={voterStore.hasMoreCash ? false : true}>Next<CaretRightOutlined /></Button></li>
                  </ul>
                  <Divider/>
                  <Title level={5}>Voters Event Registration History - <Tag color="green">RECEIVED</Tag></Title>
                  <Table pagination={false} columns={columnsReceived} dataSource={cloneDeep(voterStore.votersItemAmounts)} bordered
                    expandable={{
                      expandedRowRender: (record) => (
                        <>
                        <Title level={5}>Item Details</Title>
                        <Row gutter={20}>
                          <Col>
                            <Text type="primary">Item : </Text><Text type="primary" strong>{record.ItemName ? record.ItemName : "N/A"}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Quantity : </Text><Text type="primary" strong>{record.ItemQuantity}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Price Per Unit : </Text><Text type="primary" strong>₱{formatNumber(record.ItemPricePerUnit)}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Item Amount : </Text><Text type="primary" strong>₱{formatNumber(record.ItemTotalAmount)}</Text>
                          </Col>
                        </Row>
                        <Title level={5}>Cash Details</Title>
                        <Row gutter={20}>
                          <Col>
                            <Text type="primary">Item : </Text><Text type="primary" strong>Cash</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Cash Amount : </Text><Text type="primary" strong>₱{formatNumber(record.Cash)}</Text>
                          </Col>
                        </Row>
                        </>
                      ),
                      // rowExpandable: (record) => record.name !== 'Not Expandable',
                    }}
                  />
                  <ul className="pagination">
                    <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPageItem} disabled={voterStore.pageItem == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                    <li className="pagination-item"><a>{voterStore.pageItem}</a></li>
                    <li className="pagination-next "><Button type="dashed" onClick={handleNextPageItem} disabled={voterStore.hasMoreItem ? false : true}>Next<CaretRightOutlined /></Button></li>
                  </ul>
                  <Divider/>

                  <Title level={5}>Distributed Amount by Admin History</Title>
                  <Table pagination={false} columns={columns} dataSource={voterStore.votersAmounts} bordered/>
                  <ul className="pagination">
                    <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                    <li className="pagination-item"><a>{voterStore.page}</a></li>
                    <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                  </ul>
                </div>
              </>
            ) : <Skeleton active/>
          }
          <Divider/>
          <Row justify={'end'} gutter={10}>
            <Col>
              <Button onClick={() => navigate(-1)}>Back</Button>
            </Col>
          </Row>
        </div>
      </Content>
    </div>

  );
};

export default inject('voterStore')(observer(ViewVoter));
